import { createAction } from 'Utility/Redux';
import IPlayerData from '../../Player/IPlayerData';
import { fetchConflicts, attemptDataConflictAutoResolve } from './DataConflict/DataConflict';
import { IPlayerDataLocation, PlayerDataLocation } from '../../Utility/DataConflict/DataConflictsHelper';
import { AsyncActionStatus } from 'State/AsyncAction';
import { DataConflictRestoreSelection } from './DataConflictRestoreSelection';

export enum DataConflictsActionType {
    FETCH_CONFLICTS = 'fetchConflicts',
    START_FETCHING_CONFLICTS = 'startFetchingConflicts',
    SET_CONFLICTS = 'setConflicts',
    RESOLVE_CONFLICTS = 'resolveConflicts',
    FAILED_FETCHING_PLAYER_DATA = 'failedFetchingPlayerData',
    ACCEPT_FETCHING_PLAYER_DATA = 'acceptFailFetchingPlayerData',
    PROMPT_CONFLICT_RESOLUTION = 'promptConflictResolution',
    COMPLETE_CONFLICT_RESOLUTION = 'completeConflictResolution',
    ATTEMPT_DATA_CONFLICT_AUTO_RESOLVE = 'attemptDataConflictAutoResolve',
}

export interface IResolveDataConflictsPayload {
    data: IPlayerData;
    restoreSelection: DataConflictRestoreSelection;
    playerDataLocation: PlayerDataLocation;
}

export const DataConflictActions = {
    fetchConflicts,
    startFetchingConflicts: createAction(DataConflictsActionType.START_FETCHING_CONFLICTS),
    setConflicts: createAction(DataConflictsActionType.SET_CONFLICTS, resolve => (data: IPlayerDataLocation[]) =>
        resolve<IPlayerDataLocation[]>(data)
    ),
    promptConflictResolution: createAction(DataConflictsActionType.PROMPT_CONFLICT_RESOLUTION),
    completeConflictResolution: createAction(
        DataConflictsActionType.COMPLETE_CONFLICT_RESOLUTION,
        resolve => (status?: AsyncActionStatus) => resolve<AsyncActionStatus>(status)
    ),
    resolveConflicts: createAction(
        DataConflictsActionType.RESOLVE_CONFLICTS,
        resolve => (data: IResolveDataConflictsPayload) => resolve<IResolveDataConflictsPayload>(data)
    ),
    failFetchingPlayerData: createAction(DataConflictsActionType.FAILED_FETCHING_PLAYER_DATA),
    acceptFailFetchingPlayerData: createAction(DataConflictsActionType.ACCEPT_FETCHING_PLAYER_DATA),
    attemptDataConflictAutoResolve,
};
